import MobileDeveloperPage from "./MobileDeveloperPage";

export default function IosDeveloperPage() {
  return <MobileDeveloperPage technology="ios" />;
}
